import { Button, Icon, IconButton } from "@alm/flow-ds/components";
import SidebarContext from "contexts/SidebarContext";
import {
	isAdmin,
	isManager,
	isWorkflowDesigner,
	isFormDesigner,
} from "data/app/appSelectors";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import MenuItem from "./MenuItem";
import MenuItemLink from "./MenuItemLink";

interface Props {
	closeMenu?: () => void;
}

export default function MenuOpen({ closeMenu }: Props) {
	const { t } = useTranslation();

	// Show admin menu options if user is admin
	const admin = useSelector(isAdmin);
	const manager = useSelector(isManager);

	// Show workflow designer menu options if user is workflow designer
	const workflowDesigner = useSelector(isWorkflowDesigner);

	// show form designer menu options if user is a form designer
	const formDesigner = useSelector(isFormDesigner);

	// Sidebar cont
	const { isConfigOpen, setIsConfigOpen } = useContext(SidebarContext);

	return (
		<>
			<ul className="menu__top">
				<IconButton
					icon="times"
					iconWeight="l"
					className="btn-alt close-btn"
					label={t("common.labels.close")}
					onClick={closeMenu}
				/>
				{/* <MenuItemLink
					icon="home-lg-alt"
					name={t("main.menu.home")}
					to="/home"
				/> */}
				<MenuItemLink
					icon="list"
					name={t("main.menu.tasks")}
					to="/tasks/my-tasks"
					match="/task"
					close={closeMenu}
				/>
				{manager && (
					<MenuItemLink
						icon="clipboard-check"
						name={t("main.menu.managerTasks")}
						to="/manager/tasks"
						match="/manager/task"
						close={closeMenu}
					/>
				)}
				<MenuItemLink
					icon="search"
					name={t("main.menu.views")}
					to="/views"
					match="/views"
					close={closeMenu}
				/>
				{(admin || workflowDesigner) && (
					<>
						{/* <MenuItemLink
							icon="clipboard-check"
							name={t("main.menu.activities")}
							to="/activities"
						/> */}
						<MenuItem
							name="config"
							className={
								isConfigOpen
									? "menu__item--config-open"
									: "menu__item--config-closed"
							}>
							<Button
								onClick={e => {
									e.stopPropagation();
									setIsConfigOpen &&
										setIsConfigOpen(!isConfigOpen);
								}}>
								<Icon
									type="sliders-h"
									weight="l"
									size="sm"
									fixedWidth
								/>
								{t("main.menu.config")}
							</Button>
							{isConfigOpen && (
								<ul className="menu__collapsed">
									{workflowDesigner && (
										<MenuItemLink
											name={t("main.menu.workflows")}
											to="/workflows"
											close={closeMenu}
										/>
									)}
									{formDesigner && (
										<MenuItemLink
											name={t("main.menu.forms")}
											to="/formdesigner"
											close={closeMenu}
										/>
									)}
									{admin && (
										<>
											<MenuItemLink
												name={t("main.menu.tasks")}
												to="/admin/tasks"
												match="/admin/task"
												close={closeMenu}
											/>
											<MenuItemLink
												name={t("main.menu.activities")}
												to="/activity-instances"
												match="/activity-instance"
												close={closeMenu}
											/>
											<MenuItemLink
												name={t(
													"main.menu.administration"
												)}
												to="/admin/roles"
												match="/admin/roles"
												close={closeMenu}
											/>
											<MenuItemLink
												name={t(
													"main.menu.viewdefinition"
												)}
												to="/viewdefinitions"
												match="/viewdefinitions"
												close={closeMenu}
											/>
										</>
									)}
								</ul>
							)}
						</MenuItem>
					</>
				)}
			</ul>
			{/*<ul className="menu__bottom">
				 <MenuItemLink
					icon="cog"
					name={t("main.menu.settings")}
					to="/settings"
				/> 
				{/* <MenuItemLink
					icon="question-circle"
					name={t("main.menu.help")}
					to="/home"
				/>
				<MenuItem name="logout">
					<Button onClick={() => dispatch(logoutAction())}>
						<Icon
							type="door-closed"
							weight="l"
							size="sm"
							fixedWidth></Icon>
						{t("main.menu.logout")}
					</Button>
				</MenuItem>
			</ul>*/}
		</>
	);
}
